module.exports = __webpack_public_path__ + "10b81e7ca379a686a9ccecdf731b03ca.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-edit.svg
// module id = 6pik
// module chunks = 5